export default "__VITE_PUBLIC_ASSET__f3641ef8__"